export enum WalletType {
    METAMASK = "METAMASK",
    WALLET_CONNECT = "WALLET_CONNECT",
    IM_TOKEN = "IM_TOKEN",
    WALLETLINK_CONNECT = "WALLETLINK_CONNECT",
}
